import {
  Card,
  Input
} from 'reactstrap';
import 'rsuite/dist/rsuite.css';
import search from "../../assets/images/search.png";
import { useState, useEffect } from 'react';
import Datetime from 'react-datetime';
import documentImage from "../../assets/images/document.png"; 
import 'react-datetime/css/react-datetime.css';
import 'bootstrap/dist/css/bootstrap.css';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import download from "../../assets/images/download.png";
import PaginationTable from '../../components/status/PaginationTable';
import "./Reports.css";
import * as moment from 'moment';
import { useSelector } from "react-redux";
import {
  Autocomplete,
  TextField,
} from "@mui/material";
import { ApplicationStatusEnum } from '../../data';
import axiosInstance from '../../helpers/axios';
import { handleExcelDownload } from '../../utils/excelDownload';
import { useCurrentUser } from '../../hooks/useCurrentUser';
  
  require('moment/locale/fr');
  require('moment/locale/de');
  require('moment/locale/en-gb');
  
  const Reports = () => {
  const decode = useCurrentUser();
  const user = null;
    const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
      
    //filter
    const [searchText, setSearchText] = useState("")
    const [filterDateFrom, setFilterDateFrom] = useState('');
    const [filterDateTo, setFilterDateTo] = useState('');
    const [isLoading, setIsLoading] = useState(true); 

    const valid = (current) => {
      return current.isAfter(filterDateFrom);
      
    };
    const [selectedStatus, setSelectedStatus] = useState('');
    //table
    const [tableData, setTableData] = useState([]);
   
    //pagination
    const [currentPage, setcurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(30);
    const [searchUser, setSearchUser] = useState(null);
    const [id,setId]=useState(null)
    const [clicked,setClicked] = useState(false)
    const [totalFetchRows, setTotalFetchRows] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    // helper to build and call APIs using query params
    const fetchData = async ({overridePage, overridePerPage, forSearchUser, overrideStatus, overrideFromDate, overrideToDate, overrideInstituteId} = {}) => {
      setIsLoading(true);
      setIsFetching(true);
      const page = overridePage ?? currentPage;
      const perPage = overridePerPage ?? rowsPerPage;
      const status = overrideStatus ?? selectedStatus;
      const fromDate = overrideFromDate ?? filterDateFrom;
      const toDate = overrideToDate ?? filterDateTo;
      const instituteIdForBody = overrideInstituteId ?? id ?? decode.instituteId;

      try {
        // search for users by name (different endpoint)
        if (forSearchUser && searchUser) {
          const url = `/users/basic-info?searchField=${searchUser.length >= 5 ? searchUser : ''}`;
          const res = await axiosInstance.get(url);
          setTableData(res?.data?.data ?? []);
          setIsLoading(false);
          setIsFetching(false);
          return;
        }

        // special endpoints per status
        if (status === 'In Sanction') {
          const url = `/integrations/applications?perPage=${perPage}&pageNo=${page}`;
          const res = await axiosInstance.get(url);
          const data = res?.data?.data ?? {};
          setTableData(data.details ?? []);
          setcurrentPage(data.pagination?.currentPage ?? page);
          setTotalFetchRows(data.pagination?.totalRows ?? null);
          setrowsPerPage(data.pagination?.perPage ?? perPage);
          setIsLoading(false);
          setIsFetching(false);
          return;
        }

        if (status === 'In Disbursement') {
          const url = `/disbursement/applications?perPage=${perPage}&pageNo=${page}`;
          const res = await axiosInstance.get(url);
          const data = res?.data?.data ?? {};
          setTableData(data.details ?? []);
          setcurrentPage(data.pagination?.currentPage ?? page);
          setTotalFetchRows(data.pagination?.totalRows ?? null);
          setrowsPerPage(data.pagination?.perPage ?? perPage);
          setIsLoading(false);
          setIsFetching(false);
          return;
        }

        if (status === 'In Process') {
          const url = `/admin/application/in-progress?perPage=${perPage}&pageNo=${page}&sortOrder=-1`;
          const res = await axiosInstance.get(url);
          const data = res?.data?.data ?? {};
          setTableData(data.applicantDetails ?? []);
          setcurrentPage(data.pagination?.currentPage ?? page);
          setTotalFetchRows(data.pagination?.totalRows ?? null);
          setrowsPerPage(data.pagination?.perPage ?? perPage);
          setIsLoading(false);
          setIsFetching(false);
          return;
        }

        // default: excel/applications (POST) with query params + body
        let query = `?perPage=${perPage}&pageNo=${page}`;
        if (status) query += `&status=${status}`;

        const url = `/excel/applications${query}`;
        const body = {
          instituteId: instituteIdForBody,
          pageNo: page,
          perPage: perPage,
          fromDate: fromDate ? fromDate : undefined,
          toDate: toDate ? toDate + ' 23:59:59' : undefined,
          status: status ? status : undefined,
        };
        if (productTypeSelected && productTypeSelected !== "all") {
          body.productType = Number(productTypeSelected);
        }
        const res = await axiosInstance.post(url, body);
        const data = res?.data?.data ?? {};
        // prefer details if available else applicantDetails else fallback
        const rows = data.details ?? data.applicantDetails ?? data;
        setTableData(rows ?? []);
        setcurrentPage(data.pagination?.currentPage ?? page);
        setTotalFetchRows(data.pagination?.totalRows ?? null);
        setrowsPerPage(data.pagination?.perPage ?? perPage);
      } catch (error) {
      } finally {
        setIsLoading(false);
        setIsFetching(false);
      }
    };

    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [loadingBranches, setLoadingBranches] = useState(false);
    
    useEffect(() => {
      fetchBranches()
    }, [])

    const clearFilter = () => {
      window.location.reload()
    }


    const clearDateFilter = ()=>{
      setClicked(false)
      setFilterDateFrom('')
      setFilterDateTo('')
    }
    // fetch initial data on mount
    useEffect(() => {
      fetchData();
    }, [productTypeSelected]);

    // If searching by user name, call fetchData with forSearchUser true
    useEffect(() => {
      if (searchUser) {
        fetchData({ forSearchUser: true });
      }
    }, [searchUser]);



    const getInsituteInfo = async (text) => {
      const urlGetInstitute = `/institute/info/name?name=${text}`;
      if (text.length >= 4) {
        try {
          const res = await axiosInstance.get(urlGetInstitute);
          const foundId = res?.data?.data?.[0]?.id;
          setId(foundId);
          return foundId;
        } catch (e) {
          return null;
        }
      }
      return null;
    };
    const handleInputChange = () => {
      // when the institute search/input changes, just refetch using current filters
      fetchData();
    };


    const handleDateFilterApi = (startDate, endDate) => {
      setClicked(!clicked)
      if (startDate === "" || endDate === "") alert('Enter Date Range to Filter');
      else {
        setFilterDateFrom(startDate);
        setFilterDateTo(endDate);
        // do not auto-fetch here; wait for Search Results click
      }
    };

  const fetchBranches = async () => {
    setLoadingBranches(true);
    try {
      const res = await axiosInstance.get("/client-branches/info/clientId",
        {
          params: { clientId: decode?.clientId},
          headers: {
          },
        }); 
      setBranches(res.data.data.branches || []);
    } catch (err) {
      console.error("Error fetching branches", err);
    } finally {
      setLoadingBranches(false);
    }
  };

  const fetchBranchReport = async (branchId) => {
    setIsLoading(true);
    const data = {
      branchId,
      pageNo:currentPage,
      perPage:rowsPerPage,
    };
    if (productTypeSelected && productTypeSelected !== "all") {
      data.productType = Number(productTypeSelected);
    }
    try {
        const url = `/excel/applications?instituteId=${id}&perPage=${rowsPerPage}&pageNo=${currentPage}`;
        const res = await axiosInstance.post(url,data,{
            headers:{
          }
        })
        setTableData(res?.data?.data?.applicantDetails)
        setcurrentPage(res?.data?.data?.pagination.currentPage);
        setTotalFetchRows(res?.data?.data?.pagination.totalRows);
        setrowsPerPage(res?.data?.data?.pagination.perPage); 
    } catch (error) {
      console.error("Error fetching branch report", error); 
    }finally{
      setIsLoading(false)
    }
  }
    
const handleDownloadList = () => {
  // reuse same query param approach as fetchData
  handleExcelDownload({
    status: selectedStatus,
    instituteId: id ? id : decode.instituteId,
    fromDate: filterDateFrom,
    toDate: filterDateTo,
    productType:
      productTypeSelected && productTypeSelected !== "all"
        ? Number(productTypeSelected)
        : undefined,
    user: user,
    downloadIcon: download,
    buttonId: "downloadButton",
    buttonStyles: {
      width: "90px",
      marginLeft: "10px",
    },
  });
};


    const paginate = (pageNumber) => {
      // immediately fetch for the requested page
      setcurrentPage(pageNumber);
      fetchData({ overridePage: pageNumber });
      
  
     
//       
//       if(selectedStatus === "In Sanction"){
    
  
        
//         const createUrl = `/integrations/applications?perPage=${rowsPerPage}&pageNo=${currentPage}`;
  
//         axios.get(createUrl,{
//           headers:{
//         }
//         }).then((res)=>{
//           
//           setTableData(res?.data?.data?.details)
//           setcurrentPage(res?.data?.data?.pagination.currentPage);
//           setTotalFetchRows(res?.data?.data?.pagination.totalRows);
//           setrowsPerPage(res?.data?.data?.pagination.perPage); 
//         }).catch((error) => error)
        
//       }else if(selectedStatus === "In Disbursement"){
//         const urlUsers = `/disbursement/applications?perPage=${rowsPerPage}&pageNo=${currentPage}`;
    
//         axiosInstance.get(urlUsers,{
//           headers:{
//         }
//         }).then((res)=>{
//           
//           setTableData(res?.data?.data?.details)
//           setcurrentPage(res?.data?.data?.pagination.currentPage);
//           setTotalFetchRows(res?.data?.data?.pagination.totalRows);
//           setrowsPerPage(res?.data?.data?.pagination.perPage); 
//         }).catch((error) => error)
//       }
//       else if(selectedStatus === "In Process"){
        
//         
//         const urlUsers = `/admin/application/in-progress?perPage=${10}&pageNo=${currentPage}&sortOrder=-1`;
    
//         axiosInstance.get(urlUsers,{
//           headers:{
//         }
//         }).then((res)=>{
//           
//           setTableData(res?.data?.data?.applicantDetails)
//           setcurrentPage(res?.data?.data?.pagination.currentPage);
//           setTotalFetchRows(res?.data?.data?.pagination.totalRows);
//           setrowsPerPage(res?.data?.data?.pagination.perPage); 
//         }).catch((error) => error)
//       }else{
//         
// const data = {
  
//         instituteId:decode.instituteId,
          
//           pageNo:currentPage,
//           perPage:rowsPerPage,
//           fromDate: filterDateFrom !== null && filterDateFrom !== undefined && filterDateFrom !== "" ? filterDateFrom : undefined,
//           toDate: filterDateTo !== null && filterDateTo !== undefined && filterDateTo !== "" ? filterDateTo : undefined,
//           status: selectedStatus !== null && selectedStatus !== undefined && selectedStatus !== "" ? selectedStatus : undefined,
         
//       };

      
//       const createUrl = `/excel/applications?status=${selectedStatus}&perPage=${rowsPerPage}&pageNo=${currentPage}`;

//       axios.post(createUrl,data,{
//         headers:{
//       }
//       }).then((res)=>{
//         
//         setTableData(res?.data?.data?.applicantDetails)
//         setcurrentPage(res?.data?.data?.pagination.currentPage);
//         setTotalFetchRows(res?.data?.data?.pagination.totalRows);
//         setrowsPerPage(res?.data?.data?.pagination.perPage); 
//       }).catch((error) => error)
      
//       }

    };

    // useEffect(() => {
 
    //   handleStatusChange();
    // }, [selectedStatus]);
    // 
    // 
    // const filteredTableData = tableData?.filter((item) => {
    //   return selectedStatus === '' || item.status === selectedStatus;
    // });
  function formatNumberWithCommas(number) {
    return number.toLocaleString('en-IN'); 
  }
  
    if (tableData) {

      return (
        <Card className='card' style={{overflowX: 'hidden',width:"100%",height:'100%'}}>



           <div>
            <p style={{display:'flex',alignItems:'center'}}><img src={documentImage} alt=""/><span style={{fontFamily:'Inter-Medium',marginLeft:'10px',fontSize:'18px',color:'#D32028'}}>Reports</span></p>
            
           </div>
           <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>

  {/* Applicant Name Input */}
  <Input
    type="text"
    id="userSearch"
    placeholder="Applicant Name"
    onChange={(event) => setSearchUser(event.target.value)}
    style={{
      fontSize: '0.8vw',
      paddingLeft: '26px',
      height: '34px',
      fontFamily: 'Inter-Medium',
      backgroundImage: `url(${search})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '5px center',
      backgroundSize: '15px 15px',
      borderColor: '#cccccc',
      borderRadius: "5px",
      borderWidth: '1px',
      width: '180px' // Set a fixed width
    }}
  />

  {/* Institute Name Input */}



  {decode.role === "institute_admin" || decode.role === "institute_user"?
   <Input
   type="text"
   placeholder="Institute Name"
   value={decode.instituteName}
   readOnly
   disabled
   style={{
     fontSize: '0.8vw',
     paddingLeft: '26px',
     height: '34px',
     fontFamily: 'Inter',
     backgroundImage: `url(${search})`,
     backgroundRepeat: 'no-repeat',
     backgroundPosition: '5px center',
     backgroundSize: '15px 15px',
     borderColor: '#cccccc',
     borderRadius: "5px",
     borderWidth: '1px',
     width: '180px', // Set a fixed width
     marginLeft:'20px'
   }}
 />
   :
  <Input
    type="text"
    placeholder={decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? 'Product Type':'Merchant Name' }
    onChange={(event) => {
      // only update the local search text while typing; don't call APIs here
      setSearchText(event.target.value);
      if (event.target.value === '') {
        setSearchText("")
        clearFilter(); 
      }
    }}
    style={{
      fontSize: '0.8vw',
      paddingLeft: '26px',
      height: '34px',
      fontFamily: 'Inter',
      backgroundImage: `url(${search})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '5px center',
      backgroundSize: '15px 15px',
      borderColor: '#cccccc',
      borderRadius: "5px",
      borderWidth: '1px',
      width: '180px' // Set a fixed width
    }}
  />}

  {/* From Date Picker */}
  <Datetime
    closeOnSelect="false"
    id="fromDate"
    dateFormat="DD MMM YYYY"
    timeFormat={false}
    onChange={(event) => { 
      if (event && event.format) {
        setFilterDateFrom(event.format('DD MMM YYYY'));
      } else {
        setFilterDateFrom('');
        clearDateFilter();
      }
    }}
    locale="en-gb"
    inputProps={{
      placeholder: 'From Date',
      style: { fontFamily: 'Inter-Medium', fontSize: "14px", width: "150px" }
    }}
  />

  {/* To Date Picker */}
  <Datetime
    closeOnSelect="false"
    id="toDate"
    key={filterDateFrom} 
    dateFormat="DD MMM YYYY"
    isValidDate={valid}
    timeFormat={false}
    locale="en-gb"
    initialViewDate={
     filterDateFrom
       ? moment(filterDateFrom, 'DD MMM YYYY')
       : moment()
       }
    onChange={(event) => {
      if (event && event.format) {
        setFilterDateTo(event.format('DD MMM YYYY'));
      } else {
        setFilterDateTo(''); 
        clearDateFilter();
      }
    }}
    value={filterDateTo}
    inputProps={{
      placeholder: 'To Date',
      style: { fontFamily: 'Inter-Medium', fontSize: "14px", width: "150px" }
    }}
  />
   {decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && 
    <Box mt={2} width={180}>
      <Autocomplete
        size='small'
        options={branches}
        getOptionLabel={(option) => option.branchName || ""}
        loading={loadingBranches}
        value={selectedBranch}
        onChange={(event, value) => {
          setSelectedBranch(value);
          if (value?.branchId) {
            fetchBranchReport(value.branchId);
          }else{
            fetchBranchReport();
          }
        }}
        sx={{ width: 180,
           "& .MuiOutlinedInput-root": {
              height: "34px",
              borderRadius: "5px",
              fontFamily: "Inter",
              fontSize: "14px",
              paddingLeft: "4px",
              "& fieldset": {
                borderColor: "#cccccc",
                borderWidth: "1px",
                borderRadius: "5px",
              },
        }}}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Branch"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingBranches && (
                    <CircularProgress size={16} />
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            sx={{width: '100%',maxWidth: 200, mb:2,
                "& label.Mui-focused": {
                  color: "#000",
                  fontWeight:'500' 
                },
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#707C8B",
                  },
                  '& .MuiInputBase-input': {
                    color:'#000',
                    fontweight:'500',
                    fontFamily: 'Inter',
                    fontSize:'12px'
                  },
                },
                "& .MuiInputBase-input::placeholder": {
                  opacity: 1,
                  fontFamily: "Inter",
                  fontSize: "12px",
                }
              }}
          />
        )}
      />
    </Box> 
  }

  {/* Search Results Button */}
  <button 
    style={{
      display: 'flex',
      alignItems: 'center',
      width: '130px',
      backgroundColor: '#D22129',
      height: '34px',
      border: 'none',
      borderRadius: "5px",
      color: 'white',
      fontFamily: "Inter-Medium",
      justifyContent: "center"
    }}
    onClick={async () => {
      // when user clicks Search Results, resolve institute id if merchant name entered
      let foundId = null;
      if (searchText && searchText.length >= 4) {
        foundId = await getInsituteInfo(searchText);
      }
      // explicitly fetch using current filters (and the found institute id if any)
      fetchData({ overrideInstituteId: foundId ?? undefined, overridePage: 1 });
    }}
  >
    Search Results
  </button>

  {/* Status Dropdown */}
  <Input 
    type="select" 
    id="status" 
    style={{ width: '150px' }}  
    onChange={(e) => { 
      const v = e.target.value;
      setSelectedStatus(v);
      setcurrentPage(1);
      document.getElementById("userSearch").value = null;
      setSearchUser(null);
      // fetch explicitly for the new status
      fetchData({ overrideStatus: v, overridePage: 1 });
    }}
  >
    <option value="">Select Status</option>
    <option value={ApplicationStatusEnum.InSubmission}>In Submission</option>
    <option value={ApplicationStatusEnum.InReview}>In Review</option>
    <option value={ApplicationStatusEnum.InProcess}>In Process</option>
    <option value={ApplicationStatusEnum.InSanction}>In Sanction</option>
    <option value={ApplicationStatusEnum.InDisbursement}>In Disbursement</option>
    <option value={ApplicationStatusEnum.PendingDisbursement}>Pending Disbursement</option>
    <option value={ApplicationStatusEnum.Disbursed}>Disbursed</option>
    <option value={ApplicationStatusEnum.Dropped}>Dropped</option>
    <option value={ApplicationStatusEnum.Rejected}>Rejected</option>
    <option value={ApplicationStatusEnum.OnHold}>On Hold</option>
  </Input>

  {/* Export Button */}
  <button 
  style={{
    backgroundColor: '#D22129',
    width: '90px', // Ensures a fixed width
    minWidth: '90px', // Prevents shrinkage
    height: '34px',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    borderStyle: 'none',
    borderRadius: "5px",
    color: 'white',
    fontFamily: "Inter-Medium",
    justifyContent: "center",
    flexShrink: 0 // Prevents shrinking when contents change
  }} 
  id="downloadButton" 
  onClick={() => handleDownloadList()}
>
  <img style={{ height: '15px', marginRight: '5px', flexShrink: 0 }} src={download} alt="download" />
  <span style={{ whiteSpace: "nowrap" }}>Export</span> {/* Prevents text from wrapping */}
</button>

</div>

  
  
         

  
           {isLoading ? (
             <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%',backgroundColor:'white',height:'100vh'}}>
             <CircularProgress />
           </Box>
           ):(
            <>
            <div className='tables' style={{ marginTop: '20px', width: '100%' }}>
              
              <table>
                <thead className='table-heading' >
                  <tr >
                    <th style={{  fontSize: '14px',cursor:'pointer',fontFamily:"Inter",width:'8em',borderTopLeftRadius:'8px' }} id="appId">
                    <span style={{marginLeft:'10px'}}></span> Appl. Id 
                    </th>
                    <th  style={{  fontSize: '14px',fontFamily:"Inter",width:'10%'}} id="appname">
                     <span  style={{paddingLeft:'10px'}}></span> Appl. Name
                    </th>
                    { decode?.clientId!=='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <th  style={{  fontSize: '14px',fontFamily:"Inter",width:'7em',whiteSpace:'nowrap',paddingLeft:'10px'}} id="appname">
                     Student Name
                    </th>}

                    <th className="thead-text" style={{  fontSize: '14px',fontFamily:"Inter",borderTopRightRadius:'8px',width:'5em'}}>
                    <span style={{marginLeft:'15px'}}>{decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Product.Type" :"Merch.Name"}</span> 
                    </th>
                    <th  style={{  fontSize: '14px',fontFamily:"Inter" }} >
                  <span style={{marginLeft:'10px'}}>Mobile</span> 
                    </th>
                    {/* Email column removed */}
                    <th className="thead-text" style={{  fontSize: '14px' ,fontFamily:"Inter",width:'10em'}} >
                      <span  style={{paddingLeft:'10px'}}>{ decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Branch': 'Course'}</span>
                    </th>
                    <th className="thead-text" style={{  fontSize: '14px',cursor:'pointer',fontFamily:"Inter",width:'14em' }}>
                     <span style={{marginLeft:'15px'}}></span>  Date
                    </th>
                    
                    <th className="thead-text" style={{  fontSize: '14px',fontFamily:"Inter",width:'8em' }}>
                    <span  style={{paddingLeft:'10px'}}>Amount</span>
                    </th>
                    <th className="thead-text" style={{  fontSize: '14px',fontFamily:"Inter",width:'8em'}}>
                    Tenure
                    </th>
                    {/* PF.Amt column removed */}
                    <th className="thead-text" style={{  fontSize: '14px',fontFamily:"Inter",borderTopRightRadius:'8px',width:'5em'}}>
                    <span style={{marginLeft:'15px'}}>Status</span> 
                    </th>
                   
                  </tr>
                </thead>
               
                {tableData?.map((item,index) => {
                  return (
                    <tbody className='table-body' key={item.applicationId}>
                      <tr className="table-row" style={{ lineHeight: '14px' }}
                      >
                        {decode.role!=="institute_user"&&decode.role!=="institute_admin"&&decode.role!=="channel_user"?<td>
                         <span  style={{cursor:'pointer', fontSize: '14px', fontWeight: '500', fontFamily:'Inter' ,color:'#101828'}}> {item.applicationId}</span>
                        </td>:<td style={{  fontSize: '14px', fontWeight: '400',fontFamily:"Inter" ,color:'#101828'}}>
                          {item.applicationId}
                        </td>
                        }
                         {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="channel_user"?<td
                          style={{
                             fontSize: '14px',
                            fontFamily:"Inter",
                           fontWeight:"500",color:'#101828'
                          }}
                         
                        >
                           <span title={item.name} style={{fontFamily:"Inter",fontWeight:'400',color:'#101828',fontSize:'14px', lineHeight: '1.5em',display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'10em'}}>{item?.name?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>{' '}<br/>
                          {item.coapplicantName ? (
                            <span title={item.coapplicantName} style={{ fontSize: '14px',
                            fontFamily:"Inter",fontWeight:"500",color:'#101828', lineHeight: '1.5em',display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'10em'}}>
                              {' '}
                              {item?.coapplicantName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} ( C )
                             <div className="forInstituteDetails">
                                <span>{item.coapplicantEmail}</span>
                                <span>{item.coapplicantMobile}</span>
                                </div>

                            </span>
                          ) : (
                            ''
                          )}
                        </td>:<td
                          style={{
                             fontSize: '14px',
                            color: '#101828',
                            
                            
                            fontFamily:"Inter",
                          }}
                        >
                          <span title={item.name} style={{maxWidth:'10em',fontFamily:"Inter",fontWeight:'400',color:'#101828',fontSize:'14px',lineHeight: '1.5em',display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item?.name?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>{' '}<br/>
                          {item.coapplicantName ? (
                            <span title={item.coapplicantName} style={{maxWidth:'10em',fontFamily:"Inter",fontWeight:'400',color:'#101828',fontSize:'14px', lineHeight: '1.5em',display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                              {' '}
                              {item?.coapplicantName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} ( C )
                            </span>
                          ) : (
                            ''
                          )}
                        </td>}
                        { decode?.clientId!=='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <td title={item.studentName}>
                          <span style={{ fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter",lineHeight: '1.5em',display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'7em' }}>{item.studentName ? item.studentName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "-"}</span>
                        </td>}
                        <td title={item.instituteName } style={{ fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter" }}>
                          {/* {item.instituteName ? item.instituteName : "-"} */}
                          <span style={{fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter",display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis' ,width:'6em' }}>{item.instituteName ? item.instituteName : "-"} </span>
                        </td>
                        <td style={{ fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter" }}>
                          {item.mobile ? item.mobile : "-"}
                        </td>
                        {/* Email cell removed */}
                        <td title={item.courseName}>
                         <span style={{width:'10em', fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter",lineHeight: '1.5em',display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis' }}>{decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? item?.branchName : item.courseName ?? "-"}</span> 
                        </td>
                        <td
                          title={item.applicationDate?.substr(10, 14)}
                          style={{ fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter" ,width:'14em',whiteSpace:'nowrap'}}
                        >
                          {item.applicationDate?.substr(0, 10) ? moment(item.applicationDate?.substr(0, 10)).format('DD MMM YY') : "-" }

                        </td>
                        
                        <td style={{ fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter",maxWidth:'8em'  }}>
                         {item.courseFees ? ( <>&#8377;{formatNumberWithCommas(item.courseFees)}</>) : ( '-')}
                        </td>
                        <td style={{ fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter",maxWidth:'6em' }}>
                          {item.tenure ? item.tenure : "-"}
                        </td>
                        {/* PF.Amt cell removed */}
                        <td title={item.notes}>
                        <span style={{fontWeight: '400',  fontSize: '14px', color: '#667085',fontFamily:"Inter",display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis' ,width:'5em' }}>{item.status ? item.status : "-"}</span>  
                        </td>
                      </tr>
                      
                    
                    </tbody>
                  );
              })}
              </table>
              </div>
              {searchUser ? null : (
                <>
                  {totalFetchRows ? (
                    // The corrected and refactored condition is here
                    ((filterDateFrom && filterDateTo) || selectedStatus) && totalFetchRows <= 30 ? (
                      <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px', marginLeft: '10px', marginBottom: '5px' }}>
                        Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{totalFetchRows} records
                      </div>
                    ) : (
                      <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px', marginLeft: '10px', marginBottom: '5px' }}>
                        Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage} records
                      </div>
                    )
                  ) : (
                    <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px' }}>
                      No Records
                    </div>
                  )}
                  <PaginationTable
                    startPage="1"
                    rowsPerPage={rowsPerPage}
                    totalRows={totalFetchRows}
                    paginate={paginate}
                    currStatus={selectedStatus}
                  />
                </>
              )}
              
           
            </>

           )}
            


        </Card>
      );
    }
    return <div>....Loading</div>;
  };
  
  export default Reports;